import api from '@/services/api/api'

class ExportBoxesService {
  getAllExportBoxes () {
    return api.get('export-box').then(result => {
      return result.data
    })
  }

  saveExportBox (exportBox) {
    return api.post('export-box', exportBox)
  }

  removeExportBox (exportBox) {
    return api.delete('export-box/' + exportBox.id)
  }

  addArtworkToExportBox (exportBoxId, artworkId) {
    return api.post('export-box/' + exportBoxId + '/artwork/' + artworkId).then(response => {
      return response
    })
  }

  removeArtworkFromExportBox (exportBoxId, artworkId) {
    return api.delete('export-box/' + exportBoxId + '/artwork/' + artworkId).then(response => {
      return response
    })
  }

  getExportBoxContent (exportBoxId) {
    return api.get('export-box/' + exportBoxId + '/artwork').then(response => {
      return response.data
    })
  }
}

export default new ExportBoxesService()



// WEBPACK FOOTER //
// ./src/services/export/ExportBoxesService.js